import React from 'react';

const UserContext = React.createContext({
  user: {},
  loading: true,
  refreshUser: () => {},
});

export default UserContext;
